import { TFunction } from '@lyearn/i18n';
import { Field, FieldType } from '@/components/Form';
import { FORM_PICKLIST_PROPS } from '@/modules/corporate/components/picklist';

import { CheckboxFieldStaticConfig } from '../../checkbox/config';
import { DateFieldStaticConfig } from '../../date/config';
import { MultiSelectFieldStaticConfig } from '../../multiSelect/config';
import { NumberFieldStaticConfig } from '../../number/config';
import { RatingFieldStaticConfig } from '../../rating/config';
import { SelectFieldStaticConfig } from '../../select/config';
import { TextFieldStaticConfig } from '../../text/config';

const ALL_FIELDS_STATIC_CONFIG = [
  TextFieldStaticConfig,
  NumberFieldStaticConfig,
  CheckboxFieldStaticConfig,
  DateFieldStaticConfig,
  SelectFieldStaticConfig,
  MultiSelectFieldStaticConfig,
  RatingFieldStaticConfig,
];

const getPicklistValues = (t: TFunction) =>
  ALL_FIELDS_STATIC_CONFIG.map(({ Icon, labelKey, type }) => ({
    Icon,
    value: type,
    label: t(labelKey),
  }));

export const getDatabaseTypeFormField = (t: TFunction, disabled?: boolean): Field => ({
  name: 'metadataField.type',
  label: t('SurveyEditor:Block'),
  type: FieldType.Picklist,
  disabled,
  picklistValues: getPicklistValues(t),
  props: FORM_PICKLIST_PROPS,
});

export const getRequiredFormField = (t: TFunction): Field => ({
  name: 'viewField.required',
  label: t('Database:MarkAsOptional'),
  type: FieldType.Switch,
});

export const getDescriptionEnabledFormField = (t: TFunction): Field => ({
  name: 'viewField.descriptionEnabled',
  label: t('Common:Form.Description'),
  type: FieldType.Switch,
});

export const FormOverrides = {
  FieldContainer: { className: 'form-field' },
  Section: {
    spacing: 'space-y-32',
  },
};
